import { Trans, useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import SplashFeedback from 'utils/old-ui-commons/splash-feedback';

import { Flex, Text } from '@olist/united';

import { Container } from '../../../components/layout';
import { InternalServerError } from '../../../images';

const InternalServerErrorPage = () => {
  const { t } = useTranslation();

  const { search } = useLocation();
  const history = useHistory();

  const nextParam = new URLSearchParams(search).get('next');
  const redirectionUrl = nextParam || '/';

  const handleOnClick = () => history.push(redirectionUrl);

  return (
    <Container>
      <Flex flexDirection="column" mt="15%">
        <SplashFeedback
          imgSrc={InternalServerError}
          title={
            <Text.H3 color="foundation.primaryDefault" fontWeight="bold">
              {t`Oops! We had a problem :(`}
            </Text.H3>
          }
          link={{
            type: 'button',
            role: 'button',
            text: t`reload page`,
            variation: 'alternate',
            onClick: handleOnClick,
          }}
          subtitle={
            <>
              <Text color="foundation.shadeDark">
                <Trans i18nKey="The platform had some communication difficulties, <0/>reload the page to try again.">
                  The platform had some communication difficulties, <br />
                  reload the page to try again.
                </Trans>
              </Text>
            </>
          }
        />
      </Flex>
    </Container>
  );
};

export default InternalServerErrorPage;
